var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-content__total"},[_c('div',{staticClass:"h-content__total-btn",on:{"click":_vm.setOrder}},[_vm._v("Подробнее")])])
}
var staticRenderFns = []

export { render, staticRenderFns }